export default "__VITE_ASSET__Bw9p05q5__"